/* global t */
// Help articles for the Reports menu group. Merged into helpArticles() in help-articles.jsx.
// Screenshots use the PlummeDEMO business so no customer data is exposed.
window.PlummeHelpArticlePacks = (window.PlummeHelpArticlePacks || []).concat([() => ({
  incomeStatement: { id: 'incomeStatement', title: t('ha.incomeStatement.title'), category: t('ha.cat.reports'), read: t('ha.read2'), route: 'resultatregnskap',
    keywords: t('ha.incomeStatement.keywords'),
    lead: t('ha.incomeStatement.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.incomeStatement.period'), text: t('ha.incomeStatement.periodText') },
    { t: 'figure', src: 'src/img/help/incomeStatement-filter.png', caption: t('ha.incomeStatement.period') },
    { t: 'tip', kind: 'info', title: t('ha.report.otherYear'), text: t('ha.report.otherYearText') },
    { t: 'step', n: 2, title: t('ha.incomeStatement.read'), text: t('ha.incomeStatement.readText') },
    { t: 'step', n: 3, title: t('ha.report.drill'), text: t('ha.report.drillText') },
    { t: 'step', n: 4, title: t('ha.report.export'), text: t('ha.report.exportText') },
    { t: 'tip', kind: 'tip', title: t('ha.incomeStatement.budget'), text: t('ha.incomeStatement.budgetText') }]
  },
  trialBalance: { id: 'trialBalance', title: t('ha.trialBalance.title'), category: t('ha.cat.reports'), read: t('ha.read2'), route: 'saldobalanse',
    keywords: t('ha.trialBalance.keywords'),
    lead: t('ha.trialBalance.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.incomeStatement.period'), text: t('ha.trialBalance.periodText') },
    { t: 'step', n: 2, title: t('ha.trialBalance.columns'), text: t('ha.trialBalance.columnsText') },
    { t: 'step', n: 3, title: t('ha.trialBalance.groups'), text: t('ha.trialBalance.groupsText') },
    { t: 'step', n: 4, title: t('ha.report.drill'), text: t('ha.trialBalance.drillText') },
    { t: 'step', n: 5, title: t('ha.report.export'), text: t('ha.trialBalance.exportText') },
    { t: 'tip', kind: 'info', title: t('ha.report.otherYear'), text: t('ha.report.otherYearText') }]
  }
})]);
